__turbopack_context__.v({
  "accountForm": "EnterFlowAccountForm-module__g3H9gG__accountForm",
  "authSwitchRow": "EnterFlowAccountForm-module__g3H9gG__authSwitchRow",
  "checkboxes": "EnterFlowAccountForm-module__g3H9gG__checkboxes",
  "checkboxesIntro": "EnterFlowAccountForm-module__g3H9gG__checkboxesIntro",
  "confirmIntro": "EnterFlowAccountForm-module__g3H9gG__confirmIntro",
  "continueButton": "EnterFlowAccountForm-module__g3H9gG__continueButton",
  "errorIntro": "EnterFlowAccountForm-module__g3H9gG__errorIntro",
  "eyebrow": "EnterFlowAccountForm-module__g3H9gG__eyebrow",
  "fieldLabel": "EnterFlowAccountForm-module__g3H9gG__fieldLabel",
  "heading": "EnterFlowAccountForm-module__g3H9gG__heading",
  "input": "EnterFlowAccountForm-module__g3H9gG__input",
  "loggedInContainer": "EnterFlowAccountForm-module__g3H9gG__loggedInContainer",
  "loggedInEmailContainer": "EnterFlowAccountForm-module__g3H9gG__loggedInEmailContainer",
  "nameRow": "EnterFlowAccountForm-module__g3H9gG__nameRow",
  "registeredEmailText": "EnterFlowAccountForm-module__g3H9gG__registeredEmailText",
  "socialButtons": "EnterFlowAccountForm-module__g3H9gG__socialButtons",
  "switchToRegister": "EnterFlowAccountForm-module__g3H9gG__switchToRegister",
});
